import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.user';

const translations = {
    'user': 'Felhasználók',
    'edit.title': 'Felhasználó szerkesztése',
    'id.title': 'ID',
    'name.title': 'Név',
    'email.title': 'Email',
    'telephone.title': 'Telefon',
    'created_at.title': 'Létrehozva',
    'last_login.title': 'Utolsó belépés',
    'ext_id.title': 'Külső azonosító',
    'lyoness_card_number.title': 'Lyoness kártyszám',
    'orders_count.title': 'Megrendelések száma',
    'orders_value_sum.title': 'Megrendelések összértéke',
    'first_order_date.title': 'Első megrendelés dátuma',
    'last_order_date.title': 'Utolsó megrendelés dátuma',
    'orders.paginatorInfo.total.title': 'Megrendelések száma',
    'address.title': 'Cím',

    'tab.default': 'Alapadatok',
    'tab.addresses': 'Címek',
    'tab.order': 'Megrendelések',
    'tab.discounts': 'Kedvezmények',

    'product-discounts.title': 'Termékkedvezmények',
    'product-discounts_create': 'Új termékkedvezmény',
    'product-discounts_edit': 'Termékkedvezmény szerkesztése',
    'product-discounts.is_active.title': 'Aktív?',
    'product-discounts.discount.title': 'Mérték',
    'product-discounts.active_from.title': 'Aktív -tól',
    'product-discounts.active_to.title': 'Aktív -ig',
    'product-discounts.discountHint': 'Százalékos érték 0-100-ig. Két tizedesjegy pontosságig adható meg, pl "10,55"',

    'shipping-discounts.title': 'Szállítási kedvezmények',
    'shipping-discounts_create': 'Új szállítási kedvezmény',
    'shipping-discounts_edit': 'Szállítási kedvezmény szerkesztése',
    'shipping-discounts.is_active.title': 'Aktív?',
    'shipping-discounts.discount.title': 'Mérték',
    'shipping-discounts.active_from.title': 'Aktív -tól',
    'shipping-discounts.active_to.title': 'Aktív -ig',
    'shipping-discounts.discountHint': 'Százalékos érték 0-100-ig. Két tizedesjegy pontosságig adható meg, pl "10,55"',

    'error.wrong_url': 'Rossz hivatkozás!',
    'shipping_addresses.title': 'Szállítási címek',
    'shipping_addresses.no_data': 'Nincs mentett szállítási cím',
    'billing_addresses.title': 'Számlázási címek',
    'billing_addresses.no_data': 'Nincs mentett számlázási cím',
    'enable_transfer': 'Átutalás engedélyezése',
    'disable_transfer': 'Átutalás tiltása',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/User/lang/hu.ts